module.exports = __webpack_public_path__ + "static/fbc-banner-d6f8f40f588431fa661c730735bd7d10.jpg";